import script from "./userProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./userProgress.vue?vue&type=script&setup=true&lang=js"

import "./userProgress.vue?vue&type=style&index=0&id=82420f66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82420f66"]])

export default __exports__